/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as unityDialogReducer } from "./unityDialogSlice";
export { createNetworkErrorDialogConfig } from "./networkErrorDialog";
export {
  AUTO_HIDE_ACTION_ID,
  ON_BACK_ACTION_ID,
  showUnityDialog,
  setUnityDialog,
  dismissUnityDialog,
  resetUnityDialog,
  focusNextAction,
  focusPrevAction,
  setFocusedActionIndex,
  triggerUnityDialogAction,
  dismissUnityDialogWithoutAction,
  selectIsUnityDialogVisible,
  selectUnityDialogTitle,
  selectUnityDialogMessage,
  selectUnityDialogVariant,
  selectUnityDialogErrorCode,
  selectUnityDialogAutoHide,
  selectUnityDialogAutoHideTimeoutMs,
  selectUnityDialogOnAutoHideActionId,
  selectUnityDialogOnBackActionId,
  selectUnityDialogPriority,
  selectUnityDialogActions,
  selectUnityDialogFocusedActionIndex
} from "./unityDialogSlice";
export { UnityDialogActionRegistry } from "./UnityDialogActionRegistry";
export type {
  DialogVariant,
  UnityDialogAction,
  UnityDialogActionConfig,
  UnityDialogConfig,
  UnityDialogPayload,
  UnityDialogState
} from "./unityDialog.types";
